export default defineNuxtPlugin(async () => {
  addRouteMiddleware('02.redirect', async (to) => {
    const { isLoggedIn } = useUserSession()
    const returnUrl = useReturnUrl(to)
    if (to.path === '/') {
      if (isLoggedIn.value) {
        return navigateTo({
          name: 'dashboard.profile',
        })
      }
      return navigateTo({
        name: 'login',
        query: to.query,
      })
    }
    if (to.name === 'login' && isLoggedIn.value && !returnUrl.value) {
      return navigateTo({
        name: 'dashboard.profile',
      })
    }
  }, {
    global: true,
  })
})
